export default __webpack_public_path__ + "static/media/seedling.f5ac97fe.svg";